import { render, staticRenderFns } from "./whitelist.vue?vue&type=template&id=f9d83058&scoped=true"
import script from "./whitelist.vue?vue&type=script&lang=js"
export * from "./whitelist.vue?vue&type=script&lang=js"
import style0 from "./whitelist.vue?vue&type=style&index=0&id=f9d83058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d83058",
  null
  
)

export default component.exports